import { render, staticRenderFns } from "./ProjectLinks.vue?vue&type=template&id=ec645898&scoped=true"
import script from "./ProjectLinks.vue?vue&type=script&lang=js"
export * from "./ProjectLinks.vue?vue&type=script&lang=js"
import style0 from "./ProjectLinks.vue?vue&type=style&index=0&id=ec645898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec645898",
  null
  
)

export default component.exports